<script setup lang="ts">
import { AlertCircle, CheckCircle } from "utruckin-icons";
import { useNotification } from "@/utils/notification";

const { notificationList, deleteNotification } = useNotification();
</script>

<template>
  <div class="c-cu-alert-container">
    <TransitionGroup name="toast">
      <div
        v-for="(notification, index) in notificationList"
        :key="notification.uid"
        class="c-cu-alert"
        :style="{
          top: `${index * 12}px`,
          right: '12px',
          zIndex: 100 + index,
        }"
        @click="deleteNotification(notification.uid)"
      >
        <div class="body">
          <div class="body__icon" :class="notification.kind">
            <CheckCircle v-if="notification.kind == 'success'" :size="24" />
            <AlertCircle v-else :size="24" />
          </div>
          <div class="body__label">
            {{ notification.text }}
          </div>
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<style scoped lang="scss">
.c-cu-alert-container {
  position: fixed;
  right: 16px;
  top: 16px;
  z-index: 99999;
}

.c-cu-alert {
  position: absolute;
  min-width: 500px;
  max-width: 500px;
  background: var(--color-system-background);
  border-radius: 20px;
  box-shadow: 0px 2px 20px rgba(166, 166, 166, 0.25);
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1000;
  border: 2px solid var(--color-border);

  .body {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 12px;

    &__icon {
      background: var(--color-system-red);
      color: white;
      width: 44px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 14px;

      &.success {
        background: var(--color-system-green);
      }

      &.info {
        background: var(--color-blue-light);
      }

      &.warning {
        background: var(--color-system-orange);
      }

      &.error {
        background: var(--color-system-red);
      }
    }

    &__label {
      font-weight: 600;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: var(--color-label);

      &__secondary {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-label-secondary);
      }
    }
  }
}

/* ENTER ANIMATION */
.toast-enter-from {
  opacity: 0;
  transform: translateY(60px);
}

.toast-enter-active {
  transition: all 0.35s cubic-bezier(0.22, 1, 0.36, 1);
}

.toast-enter-to {
  opacity: 1;
  transform: translateY(0);
}

/* LEAVE ANIMATION */
.toast-leave-active {
  transition: opacity 0.4s ease;
}

.toast-leave-from {
  opacity: 1;
}

.toast-leave-to {
  opacity: 0;
}
</style>
